import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import Tree from 'react-d3-tree';
import { GetRoleById, GetRoleTree } from '../apiconfig/authService';

function ViewRole() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [mediaData, setMediaData] = useState([]);

    const [roleData, setRoleData] = useState({});
    const [treeData, setTreeData] = useState({});
    const { roleid } = useParams();
    console.log(treeData);

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetRoleById(roleid, localStorage.getItem('accessToken'));
                    setRoleData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
        (
            async () => {
                try {
                    const response = await GetRoleTree(localStorage.getItem('accessToken'));
                    setTreeData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);

    const renderCustomNode = ({ nodeDatum, toggleNode }) => {
        const isHighlighted = roleData && nodeDatum.name === roleData.rolename;


        return (
            <g>
                <circle
                    r={15}
                    fill={isHighlighted ? 'yellow' : 'steelblue'}
                    strokeWidth='1'
                />
                <text
                    x={-20}
                    y={5}
                    textAnchor="end"
                    fontSize="12px"
                    fontWeight="small"
                    fill='black'
                    style={{ cursor: 'pointer', stroke: 'black', strokeWidth: 0.5 }}
                >
                    {nodeDatum.name}
                </text>
            </g>
        );
    };


    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Role Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/role" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                        <NavLink to={`/editRole/${roleid}`} className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Role ID</th>
                                            <td>{roleData.roleid}</td>
                                        </tr>
                                        <tr>
                                            <th>Role Name</th>
                                            <td>{roleData.rolename}</td>
                                        </tr>
                                        <tr>
                                            <th>Role Description</th>
                                            <td>{roleData.roledescription}</td>
                                        </tr>
                                        <tr>
                                            <th>Role Profile</th>
                                            <td>{roleData.profileInfo?.profilename}</td>
                                        </tr>
                                        <tr>
                                            <th>Created Date</th>
                                            <td>{formatUTCDate(roleData.createddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified Date</th>
                                            <td>{formatUTCDate(roleData.modifieddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Created By</th>
                                            <td>{roleData.createdby}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified By</th>
                                            <td>{mediaData.modifiedby}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 className="text-primary h6 fw-bold" style={{ marginTop: '20px' }}>Role's Position in Hierarchy</h4>
                {treeData &&
                    <div id="treeWrapper" style={{ width: '50em', height: '20em' }}>
                        <Tree data={treeData} renderCustomNodeElement={renderCustomNode} />
                    </div>
                }
            </div>
        </div>
    );
}
export default ViewRole;